<template>
  <div>
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
    </v-overlay>

    <base-v-component heading="Patients" sub-heading="Manage Patients" />

    <template>
      <v-toolbar flat color="transparent">

        <v-spacer />

        <add-patients-to-group-dialog :patients="selected" :groups="groups" :senders="senders" @show-loader="showOverlay"
                                      @hide-loader="hideOverlay" @on-success="onPatientAddedToGroups" />

        <div class="button-separator" />

        <ivr-call-initiator :patients="selected" :templates="templates" :is-visible="ivrInitiator.isVisible"
                            @on-send-start="messageSendInitiated" @dismiss="_hideComposerDialog" @on-success="messageSent"
                            @on-test-success="testMessageSent" @on-error="messageError" />

        <v-btn color="primary" v-show="selected && selected.length && selected.length > 1" dark class="mb-2" @click="initiateCall">
          <v-icon small class="mr-2"> mdi-phone </v-icon>
          <span> Initiate Mass Call </span>
        </v-btn>

        <v-btn color="primary" v-show="selected.length && selected.length && selected.length === 1" dark class="mb-2" @click="initiateCall">
          <v-icon small class="mr-2"> mdi-phone </v-icon>
          <span> Initiate Call </span>
        </v-btn>

        <v-btn color="primary" v-show="selected.length < 1 && patients && patients.length" dark class="mb-2" @click="initiateCall">
          <v-icon small class="mr-2"> mdi-phone </v-icon>
          <span> Initiate Call </span>
        </v-btn>

        <div class="button-separator" />

        <message-composer-dialog :patients="selected" :templates="templates" :is-visible="messageComposer.isVisible"
                                 @on-send-start="messageSendInitiated" @dismiss="_hideComposerDialog" @on-success="messageSent"
                                 @on-test-success="testMessageSent" @on-error="messageError" />

        <v-btn color="primary" v-show="selected && selected.length && selected.length > 1" dark class="mb-2" @click="_composeMessage">
          <v-icon small class="mr-2"> mdi-message </v-icon>
          <span> Compose Mass Message </span>
        </v-btn>

        <v-btn color="primary" v-show="selected && selected.length && selected.length === 1" dark class="mb-2" @click="_composeMessage">
          <v-icon small class="mr-2"> mdi-message </v-icon>
          <span> Compose Message </span>
        </v-btn>

        <v-btn color="primary" v-show="selected.length < 1 && patients && patients.length" dark class="mb-2" @click="_composeMessage">
          <v-icon small class="mr-2"> mdi-message </v-icon>
          <span> Compose Message </span>
        </v-btn>

        <div class="button-separator" />

        <email-composer-dialog :patients="selected" :templates="templates" :is-visible="emailComposer.isVisible"
                               @dismiss="_hideComposerDialog" @on-send-start="messageSendInitiated" @on-success="messageSent"
                               @on-test-success="testMessageSent" @on-error="messageError" />

        <v-btn color="primary" v-show="selected.length && selected.length > 1" dark class="mb-2" @click="_composeEmail">
          <v-icon small class="mr-2"> mdi-email </v-icon>
          <span> Compose Mass Email </span>
        </v-btn>

        <v-btn color="primary" v-show="selected && selected.length && selected.length === 1" dark class="mb-2" @click="_composeEmail">
          <v-icon small class="mr-2"> mdi-email </v-icon>
          <span> Compose Email </span>
        </v-btn>

        <v-btn color="primary" v-show="selected.length < 1 && patients && patients.length" dark class="mb-2" @click="_composeEmail">
          <v-icon small class="mr-2"> mdi-email </v-icon>
          <span> Compose Email </span>
        </v-btn>

      </v-toolbar>
    </template>

    <v-toolbar flat color="transparent">
      <!-- <v-btn color="primary" dark class="mb-2" @click="_showPatientAddDialog">
        <v-icon small class="mr-2">
          mdi-plus
        </v-icon>
        <span>
          Add New Patient
        </span>
      </v-btn>
      <import-patients-dialog
        :groups="groups"
        @on-success="onPatientImportSuccess"
        @on-error="onPatientImportError"
        @on-upload-start="messageSendInitiated"
      /> -->
    </v-toolbar>

    <v-data-table v-model="selected" :headers="headers" :items="filterPatients" item-key="id" show-select
                  sort-by="firstName" :footer-props="{
        'items-per-page-options': [25, 100, 250, 500, 750, 1000]
      }" @toggle-select-all="selectAllToggle">
      <template v-for="(col, index) in filters" v-slot:[`header.${index}`]="{ header }">
        {{ header.text }}
        <v-menu :key="index" offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="filter-btn">
              <v-icon small :color="filters[header.value].length ? 'red' : 'black'">
                mdi-filter-variant
              </v-icon>
            </v-btn>
          </template>
          <div>
            <v-list>
              <v-list-item>
                <div v-if="filters.hasOwnProperty(header.value)">
                  <v-autocomplete multiple dense auto-select-first clearable chips small-chips
                                  color="light-blue lighten-3" :items="columnValueList(header.value)" append-icon="mdi-filter"
                                  v-model="filters[header.value]" :label="filters[header.value] ? `${header.text}` : ''
                      " hide-details>
                    <template v-slot:selection="{ item, index }">
                      <v-chip small class="caption" v-if="index < 5">
                        <span>
                          {{ item }}
                        </span>
                      </v-chip>
                      <span v-if="index === 5" class="grey--text caption">
                        (+{{ filters[header.value].length - 5 }} others)
                      </span>
                    </template>
                  </v-autocomplete>
                </div>
              </v-list-item>
            </v-list>
          </div>
        </v-menu>
      </template>
      <template v-slot:[`item..data-table-select`]="{ item }">
        <v-simple-checkbox :value="item.id" id="item.id" v-model="filterPatients" @change="handlePatientSelection(item)" />
      </template>
      <template v-slot:[`item.first_name`]="{ item }">
        <span class="nameLink" @click="onPatientRowClick(item)">
          {{ item.first_name }}
        </span>
      </template>
      <template v-slot:[`item.last_name`]="{ item }">
        <span class="nameLink" @click="onPatientRowClick(item)">
          {{ item.last_name }}
        </span>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <span class="patientIDValue">
          {{ item.id }}
        </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="senderActions">
          <v-btn color="primary" outlined x-small @click="_showPatientEditDialog(item)">
            Edit
          </v-btn>
          &nbsp;
          <v-icon small @click="_deletePatient(item)"> mdi-delete </v-icon>
        </div>
      </template>
      <template v-slot:no-data>
        <p class="mb-4 mt-4">No Patients to display</p>
        <v-btn color="primary" outlined class="mb-4" @click="_initiateLoad"> Refresh </v-btn>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
    <comm-validation-dialog :is-visible="commValidationPrompt.isVisible" :comm-mode="commValidationPrompt.commMode"
      :selected-patients="selected.length ? selected : filteredPatients"
      @confirm-selection="_updateSelctionAndShowComposer" @on-close="_hideCommValidationDialog" />
    <pos-patients-add-edit-dialog :is-visible="patientAddEditDialog.isVisible"
      :is-edit-mode="patientAddEditDialog.mode === 'update'" :selected-patient="patientAddEditDialog.selectedPatient"
      :groups="groups" @on-add-success="onPatientAddSuccess" @on-edit-success="onPatientEditSuccess"
      @on-close="_dismissPatientAddDialog" @on-submit-start="messageSendInitiated" />
  </div>
</template>

<script>
  /* eslint-disable */
  import { ApiCalls } from "../../../../api-calls";
  import EventEmitter from "../../../../utils/event-emitter";
  import HelperMethods from "../../../../utils/helper-methods";
  import UserHelper from "../../../../utils/user-helper";
  import IvrCallInitiator from "../ivr-call-initiator/ivr-call-initiator.vue";

  export default {
    components: {
      CommValidationDialog: () => import("../comm-validation-dialog/comm-validation-dialog.vue"),
      MessageComposerDialog: () => import("../message-composer/message-composer"),
      EmailComposerDialog: () => import("../email-composer/email-composer"),
      PosPatientsAddEditDialog: () => import("../pos-patients-add-edit-dialog/pos-patients-add-edit-dialog.vue"),
      AddPatientsToGroupDialog: () =>
        // eslint-disable-next-line implicit-arrow-linebreak
        import("../add-patients-to-group/add-patients-to-group.vue"),
      IvrCallInitiator,
    },
    props: {},
    data: () => ({
      dialog: false,
      templates: [],
      filters: { first_name: [], last_name: [], phone: [], email: [], id: [] },
      // headers: [
      //   { text: "First Name", value: "FirstName" },
      //   { text: "Last Name", value: "LastName" },
      //   { text: "Phone", value: "CellNumber" },
      //   { text: "Email", value: "email" },
      //   { text: "Group", value: "Name" },
      // ],
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Last Name", value: "last_name" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Patient ID", value: "id" },
        // { text: "Actions", value: "actions" }
      ],
      showPatientIDOnHover: false,
      snackbar: false,
      notification: "Unknown",
      selected: null,
      selectedPatients: [],
      senders: [],
      searchText: "",
      filteredPatients: [],
      patients: [],
      toNumber: "",
      isOverlayVisible: false,
      messageComposer: {
        isVisible: false,
        isBulkMode: false,
      },
      emailComposer: {
        isVisible: false,
        isBulkMode: false,
      },
      commValidationPrompt: {
        isVisible: false,
        commMode: "sms",
      },
      patientAddEditDialog: {
        isVisible: false,
        mode: "create",
        selectedPatient: null,
      },
      patientImportDialog: {
        isVisible: false,
      },
      ivrInitiator: {
        isVisible: false,
        isBulkMode: false,
      },
      groups: [],
      activeTab: "pos-patients", // Other option: 'billpay-patients'
    }),

    computed: {
      filterPatients() {
        return this.patients.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        });
      }
    },

    watch: {
      dialog(val) {
        // eslint-disable-next-line no-unused-expressions
        val || this.close();
      },
      '$store.state.posActivePractice': function () {
        // console.log('this.$store.state.posActivePractice 5814544:>> ', this.$store.state.posActivePractice);
        this._initiateLoad();
      },
      'selected': function () {
        if (this.selected.length) {

        }
      }
    },

    async created() {
      this._initiateLoad();
    },

    methods: {
      handlePatientSelection(item) {
          this.selectedPatients.splice(this.selectedPatients.indexOf(item), 1);
          this.selectedPatients.push(item);
      },
      onPatientRowClick(row) {
        console.log("row :>> ", row);
        EventEmitter.dispatch("show-patient-details", {
          ContactID: row.id,
          CellNumber: row.phone,
          selectedGroupType: row.selectedGroupType,
          MedicalGroupID: row._original.MedicalGroupID
        });
      },
      _switchTab(tab) {
        this.activeTab = tab;
      },
      async _initiateLoad() {
        // console.log('checking 5814544');

        await HelperMethods.sleepTime(400);
        await this._loadPatients();
        this._loadGroups();
        this._loadSenders();
        // Try loading templates in background
        this._loadTemplates();
      },
      async _loadGroups() {
        try {
          this.isOverlayVisible = true;
          const response = await ApiCalls.fetchGroups(this.$store.state.posActivePractice.value);
          this.groups = response && response.data && response.data.length ? response.data : [];
          // eslint-disable-next-line no-empty
        } catch (error) {
          this.groups = [];
        }
        this.isOverlayVisible = false;
      },
      async _loadSenders() {
        try {
          if (this.$store.state.posActivePractice) {
            this.isOverlayVisible = true;
            const response = await ApiCalls.fetchSenders(this.$store.state.posActivePractice.value);
            this.senders =
              response && response.data && response.data.length
                ? response.data.map((s) => ({ text: s.senderName, value: s.senderID }))
                : [];
          }
          // eslint-disable-next-line no-empty
        } catch (error) {
          this.senders = [];
        }
        this.isOverlayVisible = false;
      },
      _formatEHRPatients(patients) {
        var chunkedSize = 10000;
        var patientChunks = this._chunkArray(patients, chunkedSize);
        let formattedPatients = [];

        if (patientChunks && patientChunks.length > 0) {
          patientChunks.forEach((chunck) => {

            var mappedChuncks = chunck.map((patient) => ({
              first_name: patient.FirstName,
              last_name: patient.LastName,
              phone: patient.MobileNumber,
              email: patient.Email,
              id: patient.PatientID,
              groupId: patient.GroupID,
              medicalGroupID: patient.MedicalGroupID,
              groupName: patient.Name,
              _original: patient
            }));

            formattedPatients.push(...mappedChuncks);
          });
        }

        return formattedPatients;
      },
      //_showPatientIDOnHover(patient) {
      //  console.log(patient.id);
      //  this.showPatientIDOnHover = true;
      //},
      async _loadPatients() {
        this.selected = [];
        try {
          if (this.$store.state.posActivePractice) {
            this.isOverlayVisible = true;
            const response = await ApiCalls.fetchEhrPatients(this.$store.state.posActivePractice.value);
            const formattedPatients = this._formatEHRPatients(response.data);
            this.patients = formattedPatients;
            // Sanitize patients' numbers
            // await this._sanitizePatients();
            this._filterPatients();
          }
        } catch (error) {
          console.log("error 3 :>> ", error);
          this.patients = [];
          this.notification = "Unable to load patients";
          this.snackbar = true;
        }
        this.isOverlayVisible = false;
      },
      _chunkArray(array, chunkSize) {
        let chunkedArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
          chunkedArray.push(array.slice(i, i + chunkSize));
        }
        return chunkedArray;
      },
      async _sanitizePatients() {
        let numbersToSanitize = "";
        // Loop through all patients
        // Add the 'hasValidNumber' flag based on number availability
        // Also get the numbers to check
        const formattedPatients = this.patients.map((p) => {
          if (p.phone && p.phone.length) {
            p.hasValidNumber = true;
            numbersToSanitize += `${this._prependAreaCodeIfRequired(p.phone)};`;
          }
          return p;
        });
        try {
          const { data: numbers } = await ApiCalls.sanitizePhoneNumbers({
            PhoneNumbers: numbersToSanitize,
          });
          // Convert response numbers array into a number mapped object
          const numberMappedObject = {};
          numbers.forEach((n) => {
            numberMappedObject[n.cellNumber] = n.numberType.type;
          });
          // Iterate through patients and validate numbers
          formattedPatients.forEach((p, pIndex) => {
            if (p.hasValidNumber) {
              // Check if number is a valid mobile number
              if (
                !(
                  numberMappedObject[p.phone] &&
                  numberMappedObject[p.phone].length &&
                  numberMappedObject[p.phone] === "mobile"
                )
              ) {
                formattedPatients[pIndex].hasValidNumber = false;
              }
            }
          });
          this.patients = formattedPatients;
          // eslint-disable-next-line no-empty
        } catch (error) { }
      },
      async _loadTemplates() {
        try {
          const response = await ApiCalls.fetchTemplates();
          this.templates = response.data && response.data.length ? response.data : [];
        } catch (error) {
          this.templates = [];
        }
      },
      _prependAreaCodeIfRequired(phoneNumber) {
        if (phoneNumber && phoneNumber.length) {
          if (phoneNumber.indexOf("+1") === 0) {
            return phoneNumber;
          } else {
            return `+1${phoneNumber}`;
          }
        }
        return null;
      },
      columnValueList(val) {
        return this.patients.map((d) => d[val]);
      },
      _filterPatients() {
        this.filteredPatients = [...this.patients];
        const searchText = this.searchText.trim().toLowerCase();
        if (searchText && searchText.length) {
          // eslint-disable-next-line array-callback-return
          this.filteredPatients = this.filteredPatients.filter((c) => {
            if (
              c.first_name &&
              c.first_name.length &&
              c.first_name.toLowerCase().indexOf(searchText) > -1
            ) {
              return true;
            }
            if (
              c.last_name &&
              c.last_name.length &&
              c.last_name.toLowerCase().indexOf(searchText) > -1
            ) {
              return true;
            }
            if (c.phone && c.phone.length && c.phone.toLowerCase().indexOf(searchText) > -1) {
              return true;
            }
            if (c.email && c.email.length && c.email.toLowerCase().indexOf(searchText) > -1) {
              return true;
            }
            // Include id also
            if (c.id && c.id.length && c.id.toLowerCase().indexOf(searchText) > -1) {
              return true;
            }
          });
        }
      },
      selectAllToggle() {
        if (this.selected.length < this.filteredPatients.length) {
          // Currently selectable rows count is greater than selected rows
          // So select all
          this.selected = [];
          const self = this;
          this.filteredPatients.forEach((item) => {
            self.selected.push(item);
          });
        } else {
          // Currently selectable rows count is equal to selected rows
          // So de-select all
          this.selected = [];
        }
      },
      _showPatientEditDialog(patient) {
        this.patientAddEditDialog = {
          isVisible: true,
          mode: "update",
          selectedPatient: patient,
        };
      },
      async _deletePatient(patient) {
        if (window.confirm("Are you sure you want to remove the patient?")) {
          try {
            this.isOverlayVisible = true;
            await ApiCalls.deletePosPatient(patient.id);
            this.notification = "Patient has been removed";
            this.snackbar = true;
            // Remove the contact from the local list
            const patienttIndex = this.patients.findIndex((p) => p.id === patient.id);
            if (patienttIndex > -1) {
              this.patients.splice(patienttIndex, 1);
            }
            this._filterPatients();
            this.isOverlayVisible = false;
          } catch (error) {
            this.notification = "Unable to remove the patient";
            this.snackbar = true;
            this.isOverlayVisible = false;
          }
        }
      },
      _showPatientAddDialog() {
        this.patientAddEditDialog = {
          isVisible: true,
          mode: "create",
          selectedPatient: null,
        };
      },
      _dismissPatientAddDialog() {
        this.patientAddEditDialog = {
          isVisible: false,
          mode: "create",
          selectedPatient: null,
        };
      },
      _showPatientImportDialog() {
        this.patientImportDialog = {
          isVisible: true,
        };
      },
      _dismissPatientImportDialog() {
        this.patientImportDialog = {
          isVisible: false,
        };
      },
      onPatientImportSuccess() {
        this.notification = "Patients Imported Successfully";
        this.snackbar = true;
        this._initiateLoad();
      },
      onPatientImportError() {
        this.isOverlayVisible = false;
        this.notification = "Patients Import Failed";
        this.snackbar = true;
      },
      async onPatientAddSuccess(patient) {
        this.patients = [patient, ...this.patients];
        await this._sanitizePatients();
        this._filterPatients();
        this.isOverlayVisible = false;
        this.notification = "Patients imported successfully";
        this.snackbar = true;
      },
      async onPatientEditSuccess(patient) {
        const patientIndex = this.patients.findIndex((p) => p.id === patient.id);
        this.patients[patientIndex] = patient;
        await this._sanitizePatients();
        this._filterPatients();
        this.isOverlayVisible = false;
        this.notification = "Patient Updated Successfully";
        this.snackbar = true;
      },
      messageSendInitiated() {
        this.isOverlayVisible = true;
      },
      messageSent() {
        this.isOverlayVisible = false;
        this.notification = "Message has been sent";
        this.snackbar = true;
      },
      testMessageSent() {
        this.isOverlayVisible = false;
        this.notification = "Test message has been sent";
        this.snackbar = true;
      },
      showOverlay() {
        this.isOverlayVisible = true;
      },
      hideOverlay() {
        this.isOverlayVisible = false;
      },
      onPatientAddedToGroups() {
        this.notification = "Successfully added to groups";
        this.snackbar = true;
      },
      messageError(error) {
        let errorMessage = "";
        if (error && error.response && error.response.data && error.response.data.length) {
          errorMessage = error.response.data;
        } else {
          errorMessage = "Unable to send the message";
        }
        this.notification = errorMessage;
        this.isOverlayVisible = false;
        this.snackbar = true;
        throw error;
      },
      async _validateSelectedNumbers() {
        this.showOverlay();
        let numbersToSanitize = "";
        // Loop through all patients
        // Add the 'hasValidNumber' flag based on number availability
        // Also get the numbers to check
        const formattedPatients = this.selected.map((p) => {
          if (p.phone && p.phone.length) {
            p.hasValidNumber = true;
            numbersToSanitize += `${this._prependAreaCodeIfRequired(p.phone)};`;
          }
          return p;
        });
        try {
          let numbers = [];
          if (numbersToSanitize.length) {
            try {
              const { data } = await ApiCalls.sanitizePhoneNumbers({
                PhoneNumbers: numbersToSanitize,
              });
              numbers = data;
            } catch (error) {
              formattedPatients.forEach((p, pIndex) => {
                formattedPatients[pIndex].hasValidNumber = false;
              });
            }
          }
          // Convert response numbers array into a number mapped object
          const numberMappedObject = {};
          numbers.forEach((n) => {
            numberMappedObject[n.cellNumber] = n.numberType.type;
          });
          // Iterate through patients and validate numbers
          formattedPatients.forEach((p, pIndex) => {
            if (p.hasValidNumber) {
              // Check if number is a valid mobile number
              if (
                !(
                  numberMappedObject[p.phone] &&
                  numberMappedObject[p.phone].length &&
                  numberMappedObject[p.phone] === "mobile"
                )
              ) {
                formattedPatients[pIndex].hasValidNumber = false;
              }
            }
          });
          this.selected = formattedPatients;
          // eslint-disable-next-line no-empty
        } catch (error) { }
        this.hideOverlay();
      },
      async _composeMessage() {
        await this._validateSelectedNumbers();
        this.commValidationPrompt = {
          isVisible: true,
          commMode: "sms",
        };
      },
      _composeEmail() {
        this.commValidationPrompt = {
          isVisible: true,
          commMode: "email",
        };
      },
      _hideCommValidationDialog() {
        this.commValidationPrompt.isVisible = false;
      },
      _updateSelctionAndShowComposer(updatedPatiens) {
        this.selected = updatedPatiens;
        if (this.commValidationPrompt.commMode === "sms") {
          this.messageComposer = {
            isVisible: true,
            isBulkMode: false,
          };
        } else {
          // Email
          this.emailComposer = {
            isVisible: true,
            isBulkMode: false,
          };
        }
        this._hideCommValidationDialog();
      },
      _hideComposerDialog() {
        this.messageComposer = {
          isVisible: false,
          isBulkMode: false,
        };
        this.emailComposer = {
          isVisible: false,
          isBulkMode: false,
        };
        this.ivrInitiator = {
          isVisible: false,
          isBulkMode: false,
        };
      },
      initiateCall() {
        this.ivrInitiator = {
          isVisible: true,
          isBulkMode: false,
        };
      },
    },
  };
</script>

<style scoped>
.spinner {
  margin-left: 17rem;
}

.v-overlay.v-overlay--active.theme--dark {
  z-index: 300 !important;
}

@media only screen and (max-width: 968px) {
  .spinner {
    margin-left: 0;
  }
}

.searchBox {
  margin-left: 15px;
}
</style>

<style lang="scss">
.v-data-table-header tr th {
  padding: 0 16px !important;
}

.button-separator {
  margin: 0 15px;
}

.nameLink {
  text-decoration: underline;
  color: rgb(0, 161, 73);
  font-weight: 600;
  cursor: pointer;
}

.filter-btn {
  background-color: rgba(0, 0, 0, 0) !important;

}

  .patientIDValue {
    max-width: 25px !important;
    display: inline-block !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    padding-top: 15px !important;
  }

  .patientIDValue:hover {
    white-space: nowrap !important;
    overflow: visible !important;
  }
</style>
